import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import React from "react";
import EditBonusRule from "../components/financeComponent/editBonusRuleComponent";

export default function EditBonusRulePage() {
    return (
        <Layout>
            <Header/>
            <EditBonusRule/>
            <Footer/>
        </Layout>
    );
}